export default {
  SERVER_URL: "http://seeai-api-test.beta.hqjy.com/",
};
